import React from "react";

import {
    Autocomplete,
    Box,
    FormControl,
    FormControlLabel,
    FormLabel,
    MenuItem,
    Radio,
    RadioGroup,
    Select,
    TextField,
} from "@mui/material";

import { Source } from "Constant/source";

import MouseOverPopover from "components/MouseOverPopover";

import {
    FTP_TRANSFER_MODES,
    SFTP_READ_TYPES,
} from "../../SourceCreation.constants";
import SftpFileTree from "./SftpFileTree";

const SftpSourceForm = ({ sourceType, language, sftp }) => {
    const {
        credentials,
        setCredentialField,
        transferMode,
        setTransferMode,
        isConnected,
        isFormLocked,
        fileOptions,
        showFileSelect,
        showDirectoryTree,
        selectedFiles,
        selectedFile,
        setSelectedFile,
        treeNodes,
        treeExpanded,
        setTreeExpanded,
        handleTreeCheck,
    } = sftp;

    const handleCredentialChange = (event) =>
        setCredentialField(event.target.name, event.target.value);

    const selectFileLabel =
        language?.source_modal?.select_file ?? "Select File";

    return (
        <>
            {!isConnected && (
                <Box>
                    <FormControl
                        fullWidth
                        className="mouse-over-popover-area"
                        sx={{ mb: 3 }}
                    >
                        <TextField
                            name="domain"
                            label={language?.source_modal?.host ?? "Host"}
                            variant="outlined"
                            onChange={handleCredentialChange}
                            value={credentials.domain}
                            disabled={isFormLocked}
                        />
                        <MouseOverPopover text="Your host IP or name" />
                    </FormControl>

                    <FormControl fullWidth sx={{ mb: 3 }}>
                        <TextField
                            name="username"
                            label={
                                language?.source_modal?.username ?? "Username"
                            }
                            variant="outlined"
                            onChange={handleCredentialChange}
                            value={credentials.username}
                            disabled={isFormLocked}
                        />
                    </FormControl>

                    <FormControl fullWidth sx={{ mb: 3 }}>
                        <TextField
                            name="password"
                            label={
                                language?.source_modal?.password ?? "Password"
                            }
                            variant="outlined"
                            onChange={handleCredentialChange}
                            value={credentials.password}
                            disabled={isFormLocked}
                            type="password"
                        />
                    </FormControl>

                    {sourceType === Source.ftp && (
                        <FormControl>
                            <FormLabel id="transfer-mode-group-label">
                                {language?.source_modal?.transfer_mode ??
                                    "Transfer mode"}
                            </FormLabel>
                            <RadioGroup
                                row
                                aria-labelledby="transfer-mode-group-label"
                                name="transfer-mode"
                                value={transferMode}
                                onChange={(event) =>
                                    setTransferMode(event.target.value)
                                }
                                sx={{ mb: 3 }}
                            >
                                {FTP_TRANSFER_MODES.map((mode) => (
                                    <FormControlLabel
                                        key={mode}
                                        value={mode}
                                        disabled={isFormLocked}
                                        control={<Radio />}
                                        label={
                                            mode.charAt(0).toUpperCase() +
                                            mode.slice(1)
                                        }
                                    />
                                ))}
                            </RadioGroup>
                        </FormControl>
                    )}

                    <FormControl
                        fullWidth
                        className="mouse-over-popover-area"
                        sx={{ mb: 3 }}
                    >
                        <Select
                            name="type"
                            label={language?.source_modal?.types ?? "Types"}
                            onChange={(event) =>
                                setCredentialField("type", event.target.value)
                            }
                            value={credentials.type}
                        >
                            <MenuItem value={SFTP_READ_TYPES.FILE}>
                                {language?.source_modal?.read_file ??
                                    "Read file"}
                            </MenuItem>
                            <MenuItem value={SFTP_READ_TYPES.DIRECTORY}>
                                {language?.source_modal?.read_directory ??
                                    "Read directory"}
                            </MenuItem>
                        </Select>
                        <MouseOverPopover text="Read all file(s) under directory or single file ( Supported file(s): CSV & JSON )" />
                    </FormControl>
                </Box>
            )}

            {showFileSelect && (
                <FormControl fullWidth sx={{ mb: 3 }}>
                    <Autocomplete
                        onChange={(event, option) => setSelectedFile(option)}
                        value={selectedFile}
                        options={fileOptions}
                        getOptionLabel={(option) => option}
                        freeSolo
                        renderInput={(params) => (
                            <TextField {...params} label={selectFileLabel} />
                        )}
                    />
                </FormControl>
            )}

            {showDirectoryTree && (
                <SftpFileTree
                    nodes={treeNodes}
                    checked={selectedFiles}
                    expanded={treeExpanded}
                    onCheck={handleTreeCheck}
                    onExpand={setTreeExpanded}
                />
            )}
        </>
    );
};

export default SftpSourceForm;
